import { Feature } from "util/stdtypes";
import { NotificationConfig } from "./account-notification-permission";
import { AskForPermissionScreenPopup } from "open-modules/zdf/platform-specific/browserPushNotificationPopupClient.web"

export const AccountPushNotificationPermissionFeature: Feature<NotificationConfig, {}> = {
    name: "Push Notification Permission",
    key: "pushnotificationpermission",
    parentFeature: 'notificationpermission',
    providesConfig: {
        pushNotificationToggleEnabled: true,
    },
    subscreens: {
        browserPermission: AskForPermissionScreen
    }
}

function AskForPermissionScreen(){
    return <AskForPermissionScreenPopup />
}